import { useMytaverseEvent } from '../../../../providers';
import { useEffect, useState } from 'react';
import { getTeleportToHubDelay } from '@core/dashboard/components/DashboardContent/GameCast/GameCastLoader/helper';

export const AVERAGE_GAMELIFT_STREAMS_INIT_TIME = 3 * 60;
export const AVERAGE_UE_INITIALIZATION_TIME = 1.5 * 60;
const UPDATE_INTERVAL = 100;

export const useGameCastSteps = () => {
  const { initMessageSended, currentRoom, isStreamLoaded, currentEvent } =
    useMytaverseEvent();

  const secondStepLoading = !initMessageSended;
  const secondStepCompleted = initMessageSended;
  const thirdStepLoading = secondStepCompleted && !isStreamLoaded;
  const thirdStepCompleted = secondStepCompleted && isStreamLoaded;
  const forthStepLoading = thirdStepCompleted && !currentRoom;
  const forthStepCompleted = currentEvent?.enablePureGamecast
    ? isStreamLoaded
    : thirdStepCompleted && !!currentRoom;

  return {
    secondStepLoading,
    secondStepCompleted,
    thirdStepLoading,
    thirdStepCompleted,
    forthStepLoading,
    forthStepCompleted,
  };
};

export const useGameCastProgressBar = ({
  isStreamLoaded,
  isUeLoaded,
}: {
  isStreamLoaded: boolean;
  isUeLoaded: boolean;
}) => {
  const { currentEvent } = useMytaverseEvent();

  const [progressValue, setProgressValue] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      const latsStageDelay =
        getTeleportToHubDelay(!!currentEvent?.enablePureGamecast) / 1000;

      setProgressValue((prevProgress) => {
        if (isStreamLoaded && prevProgress < 75) {
          return 75;
        }
        if (isUeLoaded && prevProgress < 90) {
          return 90;
        }
        if (prevProgress >= 100) {
          return 100;
        }

        if (prevProgress < 75) {
          const increment =
            (70 / AVERAGE_GAMELIFT_STREAMS_INIT_TIME) *
            (UPDATE_INTERVAL / 1000);
          return Math.min(75, prevProgress + increment);
        } else if (prevProgress < 90) {
          if (!isStreamLoaded) {
            return prevProgress;
          }

          const increment =
            (15 / AVERAGE_UE_INITIALIZATION_TIME) * (UPDATE_INTERVAL / 1000);
          return Math.min(90, prevProgress + increment);
        } else {
          if (!isUeLoaded) {
            return prevProgress;
          }

          const increment = (10 / latsStageDelay) * (UPDATE_INTERVAL / 1000);
          return Math.min(100, prevProgress + increment);
        }
      });
    }, UPDATE_INTERVAL);

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [isStreamLoaded, isUeLoaded, currentEvent?.enablePureGamecast]);

  return progressValue;
};
